import { gql } from 'src/__generated__';

const GET_DEVICES_AVAILABLE_FIELDS = gql(`#graphql
query Telemetry($input: DevicesInput!) {
  devices(input: $input) {
    id
    profile {
      id
      name
    }
    metrics {
      id
      availableFields
    }
  }
}
`);

export default GET_DEVICES_AVAILABLE_FIELDS;
